<template>
  <div
    id="plan-context-menu"
    class="context-menu"
    v-show="menuShown"
    @contextmenu.prevent
  >
  <ul @click="close">
    <li class="menu" v-if="isPropertyGroupPage" @click="$emit('openEditModal', propertyData)">物件情報設定</li>
    <li class="menu" v-if="isPropertyGroupPage" @click="$emit('openEstOptionModal', propertyData)">見積オプション設定</li>
    <li class="menu" v-if="isPropertyGroupPage" @click="$emit('openOrderStatusModal', propertyData)">受注ステータス設定</li>
    <li class="menu" v-if="isPropertyGroupPage && selectedPropertyPlanList && selectedPropertyPlanList.length > 0" @click="$emit('openPreview', propertyData)">出力物プレビュー</li>
    <li class="disable_menu" v-else-if="isPropertyGroupPage">出力物プレビュー</li>
    <li class="menu" v-if="isDetailPage" @click="$emit('openEditModal', selectedPlan)">ルーム/プラン情報設定</li>
    <li class="menu" v-if="isDetailPage"  @click="$emit('openCopyModal', selectedPlan)">ルーム/プラン情報複製</li>
    <li class="menu" v-if="selectedPlan" @click="openSheetPreview(selectedPlan)">図面プレビュー</li>
  </ul>
  </div>
</template>

<script>
export default {
  name: 'PlanContextMenu',
  props: {
    selectedPlan: Object,
    isPropertyGroupPage: Boolean,
    isSalesList: Boolean,
    isConfirmedOrderList: Boolean,
    isDetailPage: Boolean,
    selectedPropertyPlanList: Array,
    fileDataList: Array
  },
  data () {
    return {
      /** メニュー開閉 */
      menuShown: false,
      /** ポジション情報 */
      sectionPoint: null,
      joinCd: null
    }
  },
  methods: {
    /** メニュ－表示 */
    show: function (position, property) {
      let element = document.getElementById('plan-context-menu')
      element.style.left = position.x + 'px'
      element.style.top = position.y + 'px'
      this.menuShown = true
      this.propertyData = property
      // 描画完了後に位置調整
      this.$nextTick(function () {
        let elementStyle = element.getBoundingClientRect()
        let clientWidth = document.documentElement.clientWidth
        if (clientWidth < elementStyle.right) {
          element.style.left = (clientWidth - elementStyle.width - 5) + 'px'
        }
        let clientHeight = document.documentElement.clientHeight
        if (clientHeight < elementStyle.bottom) {
          element.style.top = (clientHeight - elementStyle.height - 5) + 'px'
        }
      })
    },
    /** メニュ－非表示 */
    close: function (event) {
      this.menuShown = false
    },
    /** プラン新規モーダルを開く */
    openSheetModal: function () {
      this.$refs.selectSheetModalRef.showModal()
    },
    /** 図面プレビュー表示 */
    openSheetPreview: function (data) {
      if (this.selectedPlan.spaceJoincd) {
        this.joinCd = this.selectedPlan.spaceJoincd
      } else {
        this.fileDataList.forEach(file => {
          if (file.cfdId === this.selectedPlan.cpropertyRoomFdId) {
            this.joinCd = file.cspaceJoincd
          }
        })
      }
      let childWindow = ''
      if (!this.selectedPlan.dpropertyRoom || !this.selectedPlan.dpropertyRoom.cpropertyId) {
        childWindow = window.open('/#/preview?spaceJoincd=' + this.joinCd, 'sheet-page', 'width=1420, height=940')
      } else {
        childWindow = window.open('/#/preview?spaceJoincd=' + this.joinCd +
        '&propertyId=' + this.selectedPlan.dpropertyRoom.cpropertyId, 'sheet-page', 'width=1420, height=940')
      }
      childWindow.location.reload()
    }
  }
}
</script>
<style lang="scss" scoped>
#plan-context-menu {
  position: fixed;
  width: auto;
  height: auto;
  padding: 10px;
  background-color: white;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  user-select: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  font-size: 0.8em;
  font-weight: bold;
  hr {
    margin: 3px -3px;
  }
  li {
    line-height: 20px;
    &.menu {
      cursor: pointer;
      &:hover {
        color: #68C2C3;
      }
      i {
        margin-left: 0px;
        margin-right: 8px;
      }
    }
    &.disable_menu {
      color: #ccc
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/PlanContextMenu.vue